const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * POST /api/lumera/ask-stream and consume the SSE stream.
 * Calls onDelta(text) for each chunk of the explanation; resolves with the
 * final `done` event ({response, conversation_id, remaining_questions}).
 * Rejects with the `error` event payload (e.g. {limit_reached: true}).
 */
export const streamCompanionAnswer = async ({ question, conversationId, language, onDelta }) => {
  const res = await fetch(`${BACKEND_URL}/api/lumera/ask-stream`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json', Accept: 'text/event-stream' },
    body: JSON.stringify({ question, conversation_id: conversationId, language }),
  });
  if (!res.ok || !res.body) throw { error: `HTTP ${res.status}` }; // eslint-disable-line no-throw-literal

  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buffer = '';
  for (;;) {
    const { value, done } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    let sep;
    while ((sep = buffer.indexOf('\n\n')) !== -1) {
      const raw = buffer.slice(0, sep);
      buffer = buffer.slice(sep + 2);
      const line = raw.split('\n').find((l) => l.startsWith('data:'));
      if (!line) continue;
      const ev = JSON.parse(line.slice(5).trim());
      if (ev.type === 'delta') onDelta?.(ev.text || '');
      else if (ev.type === 'done') return ev;
      else if (ev.type === 'error') throw ev;
    }
  }
  throw { error: 'Stream ended unexpectedly' }; // eslint-disable-line no-throw-literal
};

export default streamCompanionAnswer;
